export default __webpack_public_path__ + "static/media/delta.58fcd557.svg";